import styled from "styled-components";
import {
  PRIMARY_COLOR,
  WHITE_COLOR,
  BLACK_COLOR,
  SECOND_COLOR,
} from "utils/const";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

export const ServicesContainer = styled.div`
  height: 950px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${PRIMARY_COLOR};

  @media (max-width: 768px) {
    height: auto;
    padding-bottom: 10px;
  }

  @media (min-width: 480px) {
    height: auto;
    padding-bottom: 10px;
  }
`;

export const ServicesWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  align-items: center;
  grid-gap: 16px;
  padding: 0 30px;
  overflow-x: auto;
  overflow-y: hidden;

  @media (max-width: 1000px) {
    grid-template-columns: repeat(3, 2fr);
    overflow-x: scroll;
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
    overflow-x: scroll;
    padding: 0 20px;
  }
`;

export const ServicesCard = styled.div`
  background-color: ${WHITE_COLOR};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  height: 300px;
  min-width: 295px;
  margin: 0 20px;
  max-height: 340px;
  padding: 30px;
  box-shadow: 0px 1px 3px rgba(${BLACK_COLOR}, 0.2);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const ServicesIcon = styled.img`
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
`;

export const ServicesH1 = styled.h1`
  margin-bottom: 64px;
  font-size: 3.5rem;
  font-weight: 700;
  color: ${WHITE_COLOR};

  @media (max-width: 480px) {
    font-size: 3rem;
  }
`;

export const ServicesH2 = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 10px;
  text-align: center;
`;

export const ServicesP = styled.p`
  font-size: 1.4rem;
  text-align: center;
`;

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1150px;
`;

export const HubWrapper = styled.div`
  padding: 10px 0;
  display: flex;
  overflow-x: hidden;
  scroll-behavior: smooth;
  scroll-snap-type: x proximity;
`;

export const ArrowContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  cursor: pointer;
`;

export const LeftArrow = styled(ArrowLeftIcon)`
  color: ${SECOND_COLOR};
`;

export const RightArrow = styled(ArrowRightIcon)`
  color: ${SECOND_COLOR};
`;
